import { useGqlMutation } from '@API/useAvQuery';
import { POST_USER_MESSAGE, START_AGENTIC_SESSION } from '@components/Copilot/gql';
import { AgenticSessionInput, UserPrompt } from '@components/Copilot/types';
import { QueryKey } from '@fabric-ui/utils';
import { UseMutationOptions } from '@tanstack/react-query';
import { GraphQLError } from 'graphql';

export const useStartAgenticSession = (
  options?: Omit<
    UseMutationOptions<{ startAgenticSession: { sessionId: string } }, GraphQLError, { agenticSessionInput: AgenticSessionInput }>,
    'variablesAdapter'
  >
) =>
  useGqlMutation<{ startAgenticSession: { sessionId: string } }, { agenticSessionInput: AgenticSessionInput }>({
    mutationKey: [QueryKey.Copilot, 'startAgenticSession'],
    mutation: START_AGENTIC_SESSION,
    ...options,
  });

export const usePostUserMessage = (options?: Omit<UseMutationOptions<boolean, GraphQLError, UserPrompt>, 'variablesAdapter'>) =>
  useGqlMutation<boolean, UserPrompt>({
    mutationKey: [QueryKey.Copilot, 'postUserMessage'],
    mutation: POST_USER_MESSAGE,
    ...options,
  });
